import React from 'react';
import Typography from '@mui/material/Typography';

const myFooterSx = {
	backgroundColor: '#222',
	color: '#ccc',
	textAlign: 'center',
	position: 'fixed',
	bottom: '18px',
	left: 0,
	right: 0,
	margin: '0 auto',
	'& > a': {
		color: 'green'
	}
};

function Footer() {
	return (
		<Typography
			variant="body2"
			color="textSecondary"
			align="center"
			sx={myFooterSx}>
			For special requests and assistance please contact us at{' '}
			<a href="mailto://support@cyberdev.us">support@cyberdev.us</a>{' '}
			CyberDev team.
		</Typography>
	);
}

export default Footer;
